export const logo=[{
    logo_White:"./Images/logo/das-tuning-car-tuning-services-dubai-logo.png",
    alt:"The logo of Das Tuning, a premium car tuning service from Dubai’s leading automotive experts."
}]